export const OPERATION = [
    { symbol: '=', operation: 'equal' },
    { symbol: '+=', operation: 'add' },
    { symbol: '-=', operation: 'substruct' },
    { symbol: '*=', operation: 'multiply' },
    { symbol: '/=', operation: 'divide' },
    { symbol: '%=', operation: 'modulo' },
    { symbol: 'Round', operation: 'round' },
    { symbol: 'Rand', operation: 'random' },
    { symbol: 'Max', operation: 'max' },
    { symbol: 'Min', operation: 'min' },
] as const;
